import React from "react";
import AboutUsImage from "assets/breakfast-event/png-jpg/hero-image.png";
// Translations
import { useTranslation } from "react-i18next";

const About = () => {
  // Translations
  const { t } = useTranslation("event");

  return (
    <div
      id="about"
      className="bg-[#0F142D] font-euclid flex justify-center items-center h-full scroll-mt-[90px]"
    >
      <div className="w-[92%] flex justify-center items-center flex-col mt-[2rem]">
        <div className="bg-[#AFF7CD33] bg-opacity-20 rounded-full px-3 py-1 w-fit font-euclidMedium">
          <p className="text-white text-base font-medium text-center">
            {t("about.tag")}
          </p>
        </div>
        <div className="flex items-start flex-col xl:flex-row gap-8 xl:gap-16 text-white my-[2rem] md:my-[4rem]">
          <h1 className="text-3xl md:text-[48px] flex-1 font-euclidSemibold">
            {t("about.title")}
          </h1>

          <p className="text-base md:text-lg font-normal flex-1 font-euclidRegular">
            {t("about.description")}
          </p>
        </div>

        <img src={AboutUsImage} alt="AboutUsImage" className="rounded-[16px]" />
      </div>
    </div>
  );
};

export default About;
